import { EChartIndicator } from '@webtrader/core/chart/indicators';
import request from '@webtrader/core/request';

export interface IGetTechnicalIndicatorParams {
  typeList: EChartIndicator;
}

export interface ITechnicalIndicator {
  type: EChartIndicator;
  value?: string;
  colors?: string;
  enabled: boolean;
}

export interface IUpdateTechnicalIndicatorParams {
  technicalIndicatorList: ITechnicalIndicator[];
}

export default {
  get: (params?: IGetTechnicalIndicatorParams) =>
    request.get<ITechnicalIndicator[]>('/api/user/v1/indicator', { params, retry: 3 }),
  update: (params: IUpdateTechnicalIndicatorParams, signal?: AbortSignal) =>
    request.patch<boolean>('/api/user/v1/indicator', params, { signal })
};
